import { createConditionalLogger } from '../../../../utils/logger';
import { useFeatureFlags } from '../../../../contexts/FeatureFlagsContext';
import { FeatureFlags } from '../../../../flags';

/**
 * React hook that returns a conditional logger based on the MEDIA_DEBUG feature flag
 */
export const useMediaLogger = (componentName: string = 'Media') => {
  const { hasFeature } = useFeatureFlags();
  const isDebugEnabled = hasFeature(FeatureFlags.NGW_MEDIA_DEBUG);

  return createConditionalLogger(isDebugEnabled, componentName);
};
